import { render } from "./InventoryPage.vue?vue&type=template&id=7e1a692c&scoped=true"
import script from "./InventoryPage.vue?vue&type=script&lang=js"
export * from "./InventoryPage.vue?vue&type=script&lang=js"

import "./InventoryPage.vue?vue&type=style&index=0&id=7e1a692c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1a692c"]])

export default __exports__